import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Subscribed", { props: { triggerType: "Form Submitted", event: "Newsletter signup" } }],
  ["e1", "auto-email", "Welcome + what to expect", { props: { subject: "You're in — here's what lands in your inbox" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e2", "auto-email", "Best of the archive", { props: { subject: "The 3 issues people forward most" } }],
  ["w2", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e3", "auto-email", "The one thing I'd do first", { props: { subject: "If I were starting over today" } }],
  ["c1", "auto-condition", "Opened any of the three?", { props: { condition: "Opened or clicked any email in this flow" } }],
  ["tg", "auto-tag-add", "Tag: engaged-subscriber", { props: { tag: "engaged-subscriber" } }],
]);

const def: TemplateDef = {
  slug: "newsletter-welcome-series",
  name: "Newsletter Welcome Series",
  category: "Lead gen",
  tagline:
    "Three emails that set expectations, prove the value, and mark who is actually reading.",
  description:
    "A free newsletter welcome sequence template: an exit-intent signup form feeds a three-email onboarding series — expectations, best-of archive, and a first-step email — then tags the subscribers who engaged. Clone it into FrazzleCRM and it sends for real.",
  whatsInside: [
    "Exit-intent popup and confirmation page wired to the signup trigger",
    "Three welcome emails spaced across the first week",
    "An engagement branch that separates readers from dead weight",
    "An engaged-subscriber tag your broadcasts can segment on",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-seo", "SEO / Organic", 40, 60, { props: { keywords: "your topic + newsletter" } }),
      node("src2", "traffic-direct", "Referrals", 40, 220, { props: { source: "Other newsletters, socials" } }),
      node("pp", "page-popup", "Exit-intent signup", 360, 140, { props: { trigger: "Exit intent" } }),
      node("ty", "page-thankyou", "Confirm your email", 680, 140),
      flow("f1", "Welcome Series", 1000, 40, 420, 856),
      ...seq.nodes,
      node("out", "outcome-lead", "Engaged subscriber", 1520, 340, { props: { source: "Newsletter" } }),
      node("n1", "util-note", "Set expectations in email one", 680, 340, {
        notes:
          "Say what you send and how often in the first email. Unsubscribes that happen in week one cost you nothing; the ones that happen in month six cost you a list you paid to build.",
      }),
    ],
    [
      edge("src1", "pp"),
      edge("src2", "pp"),
      edge("pp", "ty"),
      edge("ty", "f1"),
      ...seq.edges,
      edge("f1", "out"),
    ]
  ),
};

export default def;
